'use strict';

let module = {};

(function (module) {

    var routes = function ($stateProvider, baseState) {

        $stateProvider

            .state('' + baseState + '.clerk-ledger-deliverables', {
                abstract: true,
                url: "/ledger-deliverables",
                template: "<ui-view/>"
            })

            ;

        var views = {};
        views['@' + baseState + '.clerk-ledger-deliverables'] = {
            template: require("crud/clerk-ledger-deliverable/list.html"),
            controller: "listClerkLedgerDeliverablesController",
        };

        $stateProvider

            .state('' + baseState + '.clerk-ledger-deliverables.list', {
                url: "/list",
                views: views,
                data: {pageTitle: 'List Ledger Deliverables'}
            })

            ;

        var views = {};
        views['@' + baseState + '.clerk-ledger-deliverables'] = {
            template: "<ui-view/>",
            controller: "listClerkLedgerDeliverablesController",
        };

        $stateProvider

            .state('' + baseState + '.clerk-ledger-deliverables.curate', {
                abstract: true,
                url: "/curate",
                views: views,
                data: {pageTitle: 'Curate Ledger Deliverables'}
            })

            // Add initial alias for "first-step" TODO: Refactor to have dynamic step logic in angular logic instead of repeated code
            .state('' + baseState + '.clerk-ledger-deliverables.curate.continue-editing', {
                url: "/continue-editing",
                data: {
                    pageTitle: 'Curate Ledger Deliverable - Step \'attributes\'',
                    stepCaption: "Attributes",
                    stepMetadata: {"stepReference":"attributes","step":"attributes"},
                },
                template: require("crud/clerk-ledger-deliverable/curate-steps/attributes.html"),
                controller: "listClerkLedgerDeliverablesController",
                resolve: {
                    setRouteBasedVisibilitySettingsLevel0: /*@ngInject*/ function (routeBasedVisibilitySettings, $stateParams) {
                        routeBasedVisibilitySettings.ClerkLedgerDeliverable_columns_by_step = 'attributes';
                    },
                }
            })

            // "Attributes"
            .state('' + baseState + '.clerk-ledger-deliverables.curate.attributes', {
                url: "/attributes",
                data: {
                    pageTitle: 'Curate Ledger Deliverable - Step \'attributes\'',
                    stepCaption: "Attributes",
                    stepMetadata: {"stepReference":"attributes","step":"attributes"},
                },
                template: require("crud/clerk-ledger-deliverable/curate-steps/attributes.html"),
                controller: "listClerkLedgerDeliverablesController",
                resolve: {
                    setRouteBasedVisibilitySettingsLevel0: /*@ngInject*/ function (routeBasedVisibilitySettings, $stateParams) {
                        routeBasedVisibilitySettings.ClerkLedgerDeliverable_columns_by_step = 'attributes';
                    },
                }
            })

            // "Ledger entries progress"
            .state('' + baseState + '.clerk-ledger-deliverables.curate.ledger-entries-progress', {
                url: "/ledger-entries-progress",
                data: {
                    pageTitle: 'Curate Ledger Deliverable - Step \'ledger-entries-progress\'',
                    stepCaption: "Ledger entries progress",
                    stepMetadata: {"stepReference":"ledger-entries-progress","step":"ledger-entries-progress"},
                },
                template: require("crud/clerk-ledger-deliverable/curate-steps/ledger-entries-progress.html"),
                controller: "listClerkLedgerDeliverablesController",
                resolve: {
                    setRouteBasedVisibilitySettingsLevel0: /*@ngInject*/ function (routeBasedVisibilitySettings, $stateParams) {
                        routeBasedVisibilitySettings.ClerkLedgerDeliverable_columns_by_step = 'ledger-entries-progress';
                    },
                }
            })


            .state('' + baseState + '.clerk-ledger-deliverables.create', {
                url: "/new?basedOnClerkDeliverableId",
                params: {
                    basedOnClerkDeliverableId: {value: '', dynamic: true},
                },
                resolve: {
                    basedOnClerkDeliverableIdIfAvailable: /*@ngInject*/ function ($stateParams) {
                        console.log('optionally-by-clerk-ledger-deliverable - currentClerkDeliverable', $stateParams);
                        return $stateParams.basedOnClerkDeliverableId;
                    },
                },
                onEnter: /*@ngInject*/ function ($state, clerkLedgerDeliverable, clerkLedgerDeliverables, basedOnClerkDeliverableIdIfAvailable) {
                    let itemAttributes = {
                        'attributes': {
                            'basedOnClerkDeliverable': {
                                'id': basedOnClerkDeliverableIdIfAvailable,
                            }
                        }
                    };
                    clerkLedgerDeliverables.add(itemAttributes, function (createdItem) {
                        let goToStateParams = angular.merge($state.params, {activeClerkLedgerDeliverableId: createdItem.id});
                        $state.transitionTo(
                            '' + baseState + '.clerk-ledger-deliverables.existing.edit.guided',
                            goToStateParams,
                            {location: 'replace', inherit: true, relative: $state.$current, notify: true}
                        );
                    });
                },
                data: {pageTitle: 'New Ledger Deliverable'}
            })

            .state('' + baseState + '.clerk-ledger-deliverables.existing', {
                abstract: true,
                url: "/:activeClerkLedgerDeliverableId",
                resolve: {
                    setRouteBasedContentFiltersLevel0: /*@ngInject*/ function (routeBasedContentFilters, $stateParams) {
                        // TODO: Generate the following dynamically based on data model
                        routeBasedContentFilters.Bar_order = 'Foo.id DESC';
                        routeBasedContentFilters.Bar_foo_id = $stateParams.fooId;
                    },
                    setRouteBasedVisibilitySettingsLevel0: /*@ngInject*/ function (routeBasedVisibilitySettings, $stateParams) {
                        // TODO: Adjust the below so that columns that are all the same value due to a route-based filter are hidden
                        routeBasedVisibilitySettings.ClerkLedgerDeliverable_hide_source_relation = 'ClerkLedgerDeliverable';
                    },
                    currentClerkLedgerDeliverable: /*@ngInject*/ function ($stateParams, clerkLedgerDeliverable) {
                        let activeClerkLedgerDeliverableId = $stateParams.activeClerkLedgerDeliverableId;
                        clerkLedgerDeliverable.$activate();
                        return clerkLedgerDeliverable.load(activeClerkLedgerDeliverableId);
                    },
                },
                template: "<ui-view/>"
            })

            /*
             .state('' + baseState + '.clerk-ledger-deliverables', {
             url: "/dashboard",
             template: require("crud/clerk-ledger-deliverable/dashboard.html"),
             data: {pageTitle: 'Ledger Deliverables Dashboard'}
             })
             */

            ;

        var views = {};
        views['@' + baseState + '.clerk-ledger-deliverables'] = {
            controller: "editClerkLedgerDeliverableController",
            template: require("crud/clerk-ledger-deliverable/view.html"),
        };

        $stateProvider

            .state('' + baseState + '.clerk-ledger-deliverables.existing.view', {
                url: "/view",
                views: views,
                data: {pageTitle: 'View Ledger Deliverable'}
            })


            ;

        var views = {};
        views['@' + baseState + '.clerk-ledger-deliverables'] = {
            controller: "editClerkLedgerDeliverableController",
            template: require("crud/clerk-ledger-deliverable/components/form.html")
        };
        /*
        views['sidebar@root'] = {
            template: require("crud/clerk-ledger-deliverable/navigation.html")
        };
        */

        $stateProvider

            .state('' + baseState + '.clerk-ledger-deliverables.existing.edit', {
                abstract: true,
                url: "/edit",
                views: views,
                data: {
                    showSideMenu: true,
                    pageTitle: 'Edit Ledger Deliverable'
                }
            })

            // Add initial alias for "first-step" TODO: Refactor to have dynamic step logic in angular logic
            .state('' + baseState + '.clerk-ledger-deliverables.existing.edit.continue-editing', {
                url: "/continue-editing",
                template: require("crud/clerk-ledger-deliverable/steps/attributes.html"),
                data: {pageTitle: 'Edit Ledger Deliverable'}
            })

            // "Attributes"
            .state('' + baseState + '.clerk-ledger-deliverables.existing.edit.attributes', {
                url: "/attributes",
                template: require("crud/clerk-ledger-deliverable/steps/attributes.html"),
                data: {
                    pageTitle: 'Edit Ledger Deliverable - Step \'attributes\'',
                    stepCaption: "Attributes",
                    stepMetadata: {"stepReference":"attributes","step":"attributes"},
                }
            })

            .state('' + baseState + '.clerk-ledger-deliverables.existing.edit.attributes.attributes', {
                abstract: true,
                template: "<ui-view/>"
            })

            // "id" TYPE primary-key TODO scrollto/mark -->

            // "relevantClerkTaxEntity" TYPE has-one-relation TODO scrollto/mark -->

            // "relevantClerkFiscalYear" TYPE has-one-relation TODO scrollto/mark -->

            // "clerkLedger" TYPE has-one-relation TODO scrollto/mark -->

            // "clerkSignificantPeriod" TYPE has-one-relation TODO scrollto/mark -->

            // "clerkAmbitionLevel" TYPE has-one-relation TODO scrollto/mark -->

            // "basedOnClerkDeliverable" TYPE has-one-relation TODO scrollto/mark -->

            // "order_of_production" TYPE ordinary TODO scrollto/mark -->

            // "order_of_inspection" TYPE ordinary TODO scrollto/mark -->

            // "override_icon_class" TYPE ordinary TODO scrollto/mark -->

            // "override_label" TYPE ordinary TODO scrollto/mark -->

            // "override_description" TYPE ordinary TODO scrollto/mark -->

            // "override_artifacts_supplied_by_clerk" TYPE ordinary TODO scrollto/mark -->

            // "text" TYPE ordinary TODO scrollto/mark -->

            // "to_be_reported_to_authorities_by_utc_datetime" TYPE ordinary TODO scrollto/mark -->

            // "sent_to_accountant_utc_datetime" TYPE ordinary TODO scrollto/mark -->

            // "sent_to_auditor_utc_datetime" TYPE ordinary TODO scrollto/mark -->

            // "approved_by_auditor_utc_datetime" TYPE ordinary TODO scrollto/mark -->

            // "submitted_to_authorities_utc_datetime" TYPE ordinary TODO scrollto/mark -->

            // "marked_as_done" TYPE ordinary TODO scrollto/mark -->

            // "importSession" TYPE has-one-relation TODO scrollto/mark -->

            // "created" TYPE ordinary TODO scrollto/mark -->

            // "modified" TYPE ordinary TODO scrollto/mark -->

            // "Ledger entries progress"
            .state('' + baseState + '.clerk-ledger-deliverables.existing.edit.ledger-entries-progress', {
                url: "/ledger-entries-progress",
                template: require("crud/clerk-ledger-deliverable/steps/ledger-entries-progress.html"),
                data: {
                    pageTitle: 'Edit Ledger Deliverable - Step \'ledger-entries-progress\'',
                    stepCaption: "Ledger entries progress",
                    stepMetadata: {"stepReference":"ledger-entries-progress","step":"ledger-entries-progress"},
                }
            })

            .state('' + baseState + '.clerk-ledger-deliverables.existing.edit.ledger-entries-progress.attributes', {
                abstract: true,
                template: "<ui-view/>"
            })

            // "transaction_based_ledger_entries_deemed_good_enough" TYPE ordinary TODO scrollto/mark -->

            // "invoice_based_ledger_entries_deemed_good_enough" TYPE ordinary TODO scrollto/mark -->

            // "travel_claim_based_ledger_entries_deemed_good_enough" TYPE ordinary TODO scrollto/mark -->

            // "period_based_ledger_entries_deemed_good_enough" TYPE ordinary TODO scrollto/mark -->

            // "tax_report_based_ledger_entries_deemed_good_enough" TYPE ordinary TODO scrollto/mark -->

            // "closing_entries_ledger_entries_deemed_good_enough" TYPE ordinary TODO scrollto/mark -->

            // "custom_ledger_entries_deemed_good_enough" TYPE ordinary TODO scrollto/mark -->



        ;

    };

    module.routes = routes;

    /*
     Usage example:
     someAngularModuleThatRequiresThisItemsCrudRouting.config(function ($stateProvider) {
        routes($stateProvider, 'root.api-endpoints.existing');
    });
    */

})(module);

export default module;



// WEBPACK FOOTER //
// .-dna/app/crud/clerk-ledger-deliverable/routes.js